import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';
import { AuthService } from '../../auth/components/services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.url.includes('register')) {
            return next.handle(request);
        }
        if (!request.url.includes(environment.api)) {
            return next.handle(request);
        }
        return this.authService.getAccessToken().pipe(
            take(1),
            switchMap((token) => {
                if (token) {
                    request = request.clone({
                        setHeaders: { Authorization: `Bearer ${token}` },
                    });
                }
                return next.handle(request);
            }),
        );
    }
}
